<template>
  <AppModal
    class="confirmation-modal"
    :disabled="disabled || processing"
    :title="title"
    :size="size"
    @close="handleClose"
  >
    <template #body>
      <p class="text-base">
        <slot />
      </p>
    </template>

    <template #footer>
      <AppButtonGroup class="w-full">
        <slot name="footer">
          <AppButton
            v-if="intent !== 'info'"
            class="btn-outline btn-primary"
            :disabled="disabled || processing"
            @click="handleClose"
          >
            Cancel
          </AppButton>

          <AppButton
            :class="['btn-solid', confirmButtonConfig.color]"
            :disabled="disabled || processing"
            @click="$emit('confirm')"
          >
            <FontAwesomeIcon
              v-if="processing"
              :icon="faSpinner"
              spin
            />

            {{ processing ? confirmButtonConfig.processingText : confirmButtonConfig.text }}
          </AppButton>
        </slot>
      </AppButtonGroup>
    </template>
  </AppModal>
</template>

<script setup>
import { computed } from 'vue';

import { AppButton, AppButtonGroup, AppModal } from '@/components/app';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

const emit = defineEmits(['confirm', 'close']);

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  processing: {
    type: Boolean,
    default: false,
  },
  intent: {
    type: String,
    default: 'confirmation',
    validator: value => ['info', 'confirmation', 'success', 'warning', 'danger'].includes(value),
  },
  size: {
    type: String,
    default: 'xl',
  },
});

const confirmButtonConfig = computed(() => {
  return {
    'info': {
      text: 'Close',
      processingText: 'Closing',
      color: 'btn-secondary',
    },
    'confirmation': {
      text: 'Confirm',
      processingText: 'Confirming',
      color: 'btn-secondary',
    },
    'success': {
      text: 'Save',
      processingText: 'Saving',
      color: 'btn-success',
    },
    'warning': {
      text: 'Confirm',
      processingText: 'Confirming',
      color: 'btn-secondary',
    },
    'danger': {
      text: 'Delete',
      processingText: 'Deleting',
      color: 'btn-danger',
    },
  }[props.intent];
});

const handleClose = () => {
  if (!props.disabled && !props.processing) {
    emit('close');
  }
};

</script>
